import store from '@/store'

export default [
  {
    path: '/parent-profiles',
    name: 'parent-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/parent-profile/index.vue')
  },
  {
    path: '/parent-profiles/create',
    name: 'parent-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/parent-profile/create.vue')
  },
  {
    path: '/parent-profiles/:id',
    name: 'parent-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/parent-profile/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('parentProfile/find', to.params.id)
      next()
    }
  }
]
